export default "__VITE_ASSET__1430a9b4__"